import { Routes } from '@angular/router';
import { ARAdminLayoutComponent } from './ar/layouts/admin-layout/admin-layout.component';
import { AravocatLayoutComponent } from './ar/layouts/avocat-layout/avocat-layout.component';
import { ARUserLaouytComponent } from './ar/layouts/user-layout/user-laouyt.component';
import { ARWelcomeLayoutComponent } from './ar/layouts/welcome-layout/welcome-layout.component';
import { RegisterComponent } from './auth/register/register.component';
import { HomeComponent } from './home/home/home.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { AvocatLayoutComponent } from './layouts/avocat-layout/avocat-layout.component';
import { UserLaouytComponent } from './layouts/user-layout/user-laouyt.component';
import { WelcomeLayoutArabicComponent } from './layouts/welcome-layout/welcome-layout-arabic/welcome-layout-arabic.component';
import { WelcomeLayoutComponent } from './layouts/welcome-layout/welcome-layout.component';

export const AppRoutes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: '',
    component: UserLaouytComponent,
    children: [
        {
      path: '',
      loadChildren: './layouts/user-layout/user-layout.module#UserLayoutModule'
  }]},
  {
    path: '',
    component: AvocatLayoutComponent,
    children: [
        {
      path: '',
      loadChildren: './layouts/avocat-layout/avocat-layout.module#AvocatLayoutModule'
  }]},
  {
    path: '',
    component: AdminLayoutComponent,
    children: [
        {
      path: '',
      loadChildren: './layouts/admin-layout/admin-layout.module#AdminLayoutModule'
  }]},{
    path: 'home',
    component: WelcomeLayoutComponent,
    children: [
        {
      path: '',
      loadChildren: './layouts/welcome-layout/welcome-layout.module#WelcomeLayoutModule'
  }]}
  ,{
    path: 'ar/home',
    component: ARWelcomeLayoutComponent,
    children: [
        {
      path: '',
      loadChildren: './ar/layouts/welcome-layout/welcome-layout.module#WelcomeLayoutModule'
  }]},{
    path: 'ar/admin',
    component: ARAdminLayoutComponent,
    children: [
        {
      path: '',
      loadChildren: './ar/layouts/admin-layout/admin-layout.module#AdminLayoutModule'
  }]},
 {
    path: 'ar/user',
    component: ARUserLaouytComponent,
    children: [
        {
      path: '',
      loadChildren: './ar/layouts/user-layout/user-layout.module#UserLayoutModule'
  }]},
  {
    path: 'ar/avocat',
    component: AravocatLayoutComponent,
    children: [
        {
      path: '',
      loadChildren: './ar/layouts/avocat-layout/avocat-layout.module#AvocatLayoutModule'
  }]},
]
